module.exports = __webpack_public_path__ + "img/back_address_active2.62f696e4.png";